import { useRef } from 'react'
import Color from 'ggx-src/legacy/views/helpers/color'
import _mapValues from 'lodash/mapValues'

export default getInputs => {
  const hoverStateRef = useRef({
    isHovering: false,
    valueBeforeHover: null,
  })

  const setInputs = (value, highlight = true) => {
    Object.entries(getInputs()).forEach(([key, field]) => {
      field.value =
        value[key] || hoverStateRef.current.valueBeforeHover?.[key] || ''
      const background = highlight && value[key] ? Color.LIGHTER_BLUE : ''
      if (field.classList.contains('MuiInputBase-input')) {
        field.closest('.MuiOutlinedInput-root').style.background = background
      } else {
        field.style.background = background
      }
    })
  }

  return option => {
    if (option?.groupType === 'saved-address-book') {
      if (!hoverStateRef.current.isHovering) {
        hoverStateRef.current.valueBeforeHover = _mapValues(
          getInputs(),
          ({ value }) => value
        )
        hoverStateRef.current.isHovering = true
      }

      setInputs(option.value)
    } else if (hoverStateRef.current.isHovering) {
      setInputs(hoverStateRef.current.valueBeforeHover, false)
      hoverStateRef.current = {
        isHovering: false,
        valueBeforeHover: null,
      }
    }
  }
}
